import { type Block, type Transition } from '@/hoxStore/interface'

export function getUniqueHeightObjects(arr1: Block[], arr2: Block[]) {
  const arr = arr2.filter((item2) => {
    const index = arr1.findIndex((item1) => item1.height === item2.height)
    return index === -1
  })
  return arr
}

export function getUniqueHashObjects(arr1: Transition[], arr2: Transition[]) {
  const arr = arr2.filter((item2) => {
    const index = arr1.findIndex((item1) => item1.hash === item2.hash)
    return index === -1
  })
  return arr
}

export function findDifferencesWithSet(
  arr1: { [keys: string]: any },
  arr2: { [keys: string]: any },
  key: string,
) {
  const set1 = new Set(arr1.map((item: any) => item[key]))
  const set2 = new Set(arr2.map((item: any) => item[key]))

  const onlyInArr1 = arr1.filter((item: any) => !set2.has(item[key]))
  const onlyInArr2 = arr2.filter((item: any) => !set1.has(item[key]))

  return {
    onlyInArr1,
    onlyInArr2,
    differences: [...onlyInArr1, ...onlyInArr2],
  }
}
